module.exports = __webpack_public_path__ + "static/logo-8e242bac182dd61a36abdecc7c36ec2d.png";